
import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getCurrentRegion (routing = {}) {
  let {region = ROUTING_STATE_SHAPE.getAt(routing, ['defaultRegion'])} = ROUTING_STATE_SHAPE.getAt(routing, ['current', 'params']) || {};
  return region;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getCurrentRegion.js